import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import styled from "styled-components";
import { Panel, Input } from "components/bootstrap";
import Select from "components/common/Select";
import { naturalSortIgnoreCase } from "util/SortUtils";
import Spinner from "components/common/Spinner";
const StyledInlineCode = styled("code")`
  margin: 0 0.25em;
  white-space: nowrap;
`;
const EXAMPLE_QUERY = '("foo" OR "bar" OR "baz")';
const WILDCARD = "*";
const MAX_CLAUSE_COUNT_SETTING = "opensearch_indices_query_bool_max_clause_count";
const LookupTableParameterEdit = ({
  validationState = {},
  onChange,
  lookupTables,
  identifier,
  parameter = {},
  defaultExpandHelp = true
}) => {
  var _a, _b, _c, _d, _e;
  const { t } = useTranslation("lookup_tables");
  const { lookupTable, key: tableKey, defaultValue, name } = parameter;
  const parameterSyntax = `$${name}$`;
  const _handleChange = (fieldName) => (value) => {
    onChange(fieldName, value);
  };
  const _handleInputChange = (attributeName) => ({ target: { value } }) => _handleChange(attributeName)(value);
  if (!lookupTables) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: t("parameter_edit.loading") });
  }
  const lookupTableOptions = lookupTables.sort((lt1, lt2) => naturalSortIgnoreCase(lt1.title, lt2.title)).map((table) => ({ label: table.title, value: table.name }));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `lookup-table-parameter-table-${identifier}`,
      name: "query-param-table-name",
      label: t("parameter_edit.table_label"),
      bsStyle: (_a = validationState == null ? void 0 : validationState.lookupTable) == null ? void 0 : _a[0],
      error: (_b = validationState == null ? void 0 : validationState.lookupTable) == null ? void 0 : _b[1],
      help: t("parameter_edit.table_help")
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        placeholder: t("parameter_edit.table_placeholder"),
        onChange: _handleChange("lookupTable"),
        options: lookupTableOptions,
        value: lookupTable,
        autoFocus: true,
        clearable: false,
        required: true
      }
    )
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: `lookup-table-parameter-key-${identifier}`,
      label: t("parameter_edit.key_label"),
      name: "key",
      defaultValue: tableKey,
      onChange: _handleInputChange("key"),
      bsStyle: (_c = validationState == null ? void 0 : validationState.key) == null ? void 0 : _c[0],
      help: t("parameter_edit.key_help"),
      error: ((_d = validationState == null ? void 0 : validationState.key) == null ? void 0 : _d[0]) === "error" ? (_e = validationState == null ? void 0 : validationState.key) == null ? void 0 : _e[1] : void 0,
      spellCheck: false,
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `lookup-table-parameter-default-value-${identifier}`,
      type: "text",
      name: "defaultValue",
      label: t("parameter_edit.default_value_label"),
      help: t("parameter_edit.default_value_help"),
      defaultValue,
      spellCheck: false,
      onChange: _handleInputChange("defaultValue")
    }
  ), /* @__PURE__ */ React.createElement(Panel, { id: "lookup-table-parameter-help", defaultExpanded: defaultExpandHelp }, /* @__PURE__ */ React.createElement(Panel.Heading, null, /* @__PURE__ */ React.createElement(Panel.Title, { toggle: true }, t("parameter_edit.help_title"))), /* @__PURE__ */ React.createElement(Panel.Collapse, null, /* @__PURE__ */ React.createElement(Panel.Body, null, /* @__PURE__ */ React.createElement("h5", null, t("parameter_edit.general_usage_title")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "parameter_edit.general_usage",
      values: { parameter: parameterSyntax, example: EXAMPLE_QUERY },
      components: { inlineCode: /* @__PURE__ */ React.createElement(StyledInlineCode, null) }
    }
  )), /* @__PURE__ */ React.createElement("h5", null, t("parameter_edit.empty_result_title")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "parameter_edit.empty_result",
      values: { wildcard: WILDCARD },
      components: { emphasis: /* @__PURE__ */ React.createElement("i", null), inlineCode: /* @__PURE__ */ React.createElement(StyledInlineCode, null) }
    }
  )), /* @__PURE__ */ React.createElement("h5", null, t("parameter_edit.limitations_title")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "parameter_edit.limitations",
      values: { setting: MAX_CLAUSE_COUNT_SETTING },
      components: { inlineCode: /* @__PURE__ */ React.createElement(StyledInlineCode, null) }
    }
  ))))));
};
export default LookupTableParameterEdit;
